
import { computed, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import ProposedUniqueBlocks from "../../helpers/pages/ProposedUniqueBlocks";
import moment from "moment";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { Roles } from "@/helpers/enums/Roles";
import dateOptions from "@/helpers/DateOptions";

let filter: any = ref({
  page: 1,
  limit: 5,
  startDate: moment()
    .utc()
    .add(-1, "months")
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS"),
  endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
  terms: [],
  fields: [],
  eventTypeKeyword: "",
  severity: "",
  facility: null,
  os: null,
  code: null,
  commandLine: "",
  policyFileVersion: "",
  eventCount: null,
  membershipType: "",
  type: "",
  agentVersion: "",
  "_source": true,
  user: "",
  groupIds: "",
  agscEventType: "",
  sortColumn: "",
  sortDir: "asc",
});
const store = useStore();
const module = ref(ProposedUniqueBlocks);

const getList = (
  filters = filter.value,
  options = module.value.component.options
) => {
  const body = { filters, options };
  store.dispatch(GeneralActionTypes.GET_PROPOSED_UNIQUE_BLOCKS, body);
};
export default defineComponent({
  name: "ProposedUniqueBlocks",
  components: { AgCard },
  setup() {
    const user: any = computed(() => store.getters.loggedInUser);
    const group: any = computed(() => store.getters.group);

    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };

    const RESETFILTER = filter;

    const searchWithFilters = (param: any) => {

      if (user.value.role == Roles.GroupAdmin) {
        filter.value.groupIds = group.value.key == "" ? null : group.value.key;
      }
      filter.value.groupIds = module.value.filter.filters[0].vmodel || null;

      filter.value.type = module.value.filter.filters[1].vmodel || null;
      filter.value.severity = module.value.filter.filters[2].vmodel || "";
      filter.value.facility = module.value.filter.filters[3].vmodel || null;
      filter.value.os = module.value.filter.filters[4].vmodel || null;
      filter.value.code = module.value.filter.filters[5].vmodel || null;
      filter.value.commandLine = module.value.filter.filters[6].vmodel || null;
      filter.value.policyFileVersion = module.value.filter.filters[7].vmodel || null;
      filter.value.eventCount = module.value.filter.filters[8].vmodel || "";
      filter.value.membershiptype = module.value.filter.filters[9].vmodel || "";
      filter.value.agentVersion = module.value.filter.filters[10].vmodel || "";
      filter.value.user = module.value.filter.filters[11].vmodel || "";
      filter.value.user = module.value.filter.filters[11].vmodel || "";
      filter.value.policyDownloadDate =
        module.value.filter.filters[13].vmodel || "";

      const range: any = module.value.filter.filters.find(
        (f) => f.param == "range"
      );

      if (param) {
        filter.value.startDate = moment().utc().startOf("day").subtract(7, "days");
        filter.value.endDate = moment().utc();
      } else {
        if (range && range.vmodel && range.vmodel.start) {
          filter.value.startDate = range.vmodel.start;
          filter.value.endDate = range.vmodel.end;
        } else {
          const findDate = module.value.filter.filters.find(
            (f) => f.param == "range"
          );
          filter.value.endDate = moment().utc();
          if (findDate && findDate.vmodel) {
            filter.value.startDate = findDate.vmodel;
          } else {
            filter.value.startDate = moment()
              .utc()
              .startOf("day")
              .utc()
              .subtract(7, "days");
          }
        }
      }

      const filters = filter.value;
      const options = module.value.component.options;
      module.value.readyToUseFilters = filters;
      options.page = 1;

      getList(filters, options);
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item: any) => {
        if (item.param == "range") {
          item.vmodel = dateOptions[2].value;
          item.selectedLabel = dateOptions[2].label;
        } else {
          item.vmodel = null;
        }
      });

      searchWithFilters(true);
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      module,
    };
  },
  mounted() {
    this.setFilterStatus();
    const filters = this.filter;
    // this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    getList(filters, options);
  },
  getList,
});
